import { api } from './api';

export interface AdfTable {
  headers: string[];
  rows: string[][];
}

export type YesNo = 'yes' | 'no' | null;

export interface TexecHeader {
  orderType: string | null;
  testedJurisdictions: string[];
  studio: string | null;
}

export interface TexecProductData {
  gameName: string | null;
  gameId: string | null;
  gameVersion: string | null;
  gameType: string | null;
  gameFeatures: string[];
  clientRtps: AdfTable | null;
  hasJackpot: YesNo;
  hasBuyFeature: YesNo;
  hasBuyChance: YesNo;
  hasSideBet: YesNo;
  hasGamble: YesNo;
  hasBranding: YesNo;
  productScope: string[];
}

export interface TexecReportData {
  jurisdictions: string[];
}

export interface TexecLinkedWorkItem {
  key: string;
  summary: string;
  status: string | null;
  linkType: string | null;
}

export interface TexecMeta {
  /** ISO timestamp of the fetch that produced this view. */
  fetchedAt: string;
  /** True when the live Jira fetch failed and we fell back to cached data. */
  stale: boolean;
  /** Human-readable explanation of why `stale` is true (DNS error, etc.). */
  staleReason?: string;
  /** Jira host the data came from, when known; used to render diagnostics. */
  jiraHost?: string;
}

export interface TexecViewModel {
  key: string;
  summary: string;
  header: TexecHeader;
  productData: TexecProductData;
  reportData: TexecReportData;
  linkedWorkItems: TexecLinkedWorkItem[];
  meta?: TexecMeta;
}

/**
 * Read-only view of the Jira TEXEC issue used by Phase 1. Mirrors the shape
 * built by `GET /api/runs/:id/texec` on the server (see runs.ts). The server
 * caches the last successful response on disk and falls back to it when Jira
 * is unreachable - in that case `meta.stale` will be true and the panel
 * surfaces a banner.
 */
export const texecApi = {
  load: (runId: string) => api.get<TexecViewModel>(`/api/runs/${runId}/texec`),
};
